'use client';

import type { ReactNode } from 'react';
import { MdErrorOutline, MdOutlineInbox } from 'react-icons/md';

import { widgetEmptyClassName, widgetEmptySurfaceClassName } from './widgetChrome';

export const WidgetStatus = ({
  action,
  children,
  className,
  description,
  title,
  tone = 'empty',
}: {
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
  description: string;
  title: string;
  tone?: 'empty' | 'error';
}) => {
  const Icon = tone === 'error' ? MdErrorOutline : MdOutlineInbox;
  return (
    <div
      className={className ? `${widgetEmptySurfaceClassName} ${className}` : widgetEmptyClassName}
      role={tone === 'error' ? 'alert' : 'status'}
    >
      <span
        aria-hidden
        className={`flex size-11 items-center justify-center rounded-full ${
          tone === 'error' ? 'bg-bzred-100 text-bzred-500' : 'bg-bzblue-300 text-bzblue-700'
        }`}
      >
        <Icon size={22} />
      </span>
      <div className="flex max-w-sm flex-col gap-3">
        <p className="text-balance text-[15px] font-extrabold tracking-tight text-slate-950">{title}</p>
        <p className="text-pretty text-sm leading-relaxed text-slate-600">{description}</p>
      </div>
      {action ? <div className="flex flex-wrap justify-center gap-2">{action}</div> : null}
      {children}
    </div>
  );
};
